import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import ExtensionIcon from '@material-ui/icons/Extension';
import GavelIcon from '@material-ui/icons/Gavel';
import HomeIcon from '@material-ui/icons/Home';
import InputIcon from '@material-ui/icons/Input';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import KeyboardIcon from '@material-ui/icons/Keyboard';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MapIcon from '@material-ui/icons/Map';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PermMediaIcon from '@material-ui/icons/PermMedia';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import VideocamIcon from '@material-ui/icons/Videocam';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ApiIcon from '@mui/icons-material/Api';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import IosShareIcon from '@mui/icons-material/IosShare';
import MonitorIcon from '@mui/icons-material/Monitor';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import RouteIcon from '@mui/icons-material/Route';
import VideoCameraBackOutlinedIcon from '@mui/icons-material/VideoCameraBackOutlined';
import PeopleIcon from '@mui/icons-material/People';
import WebhookIcon from '@mui/icons-material/Webhook';

const icons = {
    api: RouteIcon,
    absence: NotificationsActiveIcon,
    cameraLog: VideocamIcon,
    case: GavelIcon,
    caseFile: PermMediaIcon,
    category: ListAltIcon,
    credential: CreditCardIcon,
    customInput: InputIcon,
    device: AccountTreeOutlinedIcon,
    deviceCamera: VideoCameraBackOutlinedIcon,
    deviceGroup: ApiIcon,
    export: IosShareIcon,
    functionality: ExtensionIcon,
    map: MapIcon,
    notification: NotificationImportantIcon,
    operationLog: AssignmentIcon,
    organization: AccountTreeIcon,
    people: AccessibilityIcon,
    person: PeopleIcon,
    personLog: MeetingRoomIcon,
    place: HomeIcon,
    profile: AssignmentIndIcon,
    security: MonitorIcon,
    shortcut: KeyboardIcon,
    vehicle: DirectionsCarIcon,
    vehicleType: CarRepairIcon,
    webhook: WebhookIcon,
};

export function ListPageHeading({ icon, title }) {
    const classes = useStyles();
    const Icon = icons[icon] || InsertDriveFileIcon;

    return (
        <div className={classes.heading}>
            <div className={classes.headingIcon}>
                <Icon />
            </div>
            <Typography variant="h5" className={classes.title}>
                {title}
            </Typography>
        </div>
    );
}

export function ListTableCard({ title, subtitle, actions, children }) {
    const classes = useStyles();

    return (
        <div className={classes.tableCard}>
            <div className={classes.cardHeader}>
                <div>
                    <Typography className={classes.cardTitle}>
                        {title}
                    </Typography>
                    <Typography className={classes.cardSubtitle}>
                        {subtitle}
                    </Typography>
                </div>
                {!!actions && (
                    <div className={classes.cardActions}>
                        {actions}
                    </div>
                )}
            </div>
            {children}
        </div>
    );
}

export function listResultSubtitle(total) {
    return `${total} ${total === 1
        ? 'registro encontrado'
        : 'registros encontrados'}`;
}

const useStyles = makeStyles((theme) => ({
    heading: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    headingIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        flexShrink: 0,
        borderRadius: 14,
        color: '#1d4ed8',
        background: 'linear-gradient(135deg, #dbeafe 0%, #eef2ff 100%)',
        '& svg': {
            fontSize: 27,
        },
    },
    title: {
        color: 'rgba(6, 19, 31, 1)',
        fontSize: 28,
        fontWeight: 600,
    },
    tableCard: {
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        backgroundColor: '#fff',
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
        '& > .MuiPaper-root': {
            borderRadius: 0,
            boxShadow: 'none',
        },
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(3),
        padding: theme.spacing(2.5, 3),
        borderBottom: '1px solid #e5e7eb',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
            gap: theme.spacing(2),
            padding: theme.spacing(2),
        },
    },
    cardTitle: {
        color: '#1f2937',
        fontSize: 16,
        fontWeight: 700,
    },
    cardSubtitle: {
        color: '#9ca3af',
        fontSize: 12,
        marginTop: 2,
    },
    cardActions: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.25),
        '& .MuiTextField-root': {
            minWidth: 260,
        },
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            width: '100%',
            '& > *': {
                maxWidth: '100%',
            },
            '& .MuiTextField-root': {
                minWidth: 0,
                width: '100%',
            },
        },
    },
}));
